export class ServerError extends Error {
	status: number;
	url: string | null;
	statusText: string;
	stack: string | undefined;

	constructor(message: string, status: number, url: string | null, statusText: string, stackTrace: string | null) {
		super(message);
		this.name = this.constructor.name;
		this.status = status;
		this.url = url;
		this.statusText = statusText;
		this.stack = stackTrace ?? undefined;

		Object.setPrototypeOf(this, ServerError.prototype);
	}

	static fromBackendException(name: string, url: string | null, errorMessage: string, stackTrace: string | null): ServerError {
		const error = new ServerError(errorMessage, 500, url, "Server Error", stackTrace);
		error.name = name;
		return error;
	}
}
